// extracted by mini-css-extract-plugin
export default {"mock":"MockSelector-module--mock--e631c","selector":"MockSelector-module--selector--8c3df","zig":"MockSelector-module--zig--a50c6","pointer":"MockSelector-module--pointer--f14c7"};